module.exports = __webpack_public_path__ + "images/places/training_743-a2a72ff880f4bccdf8dafdecc02958ec.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_743.jpg
 ** module id = 329
 ** module chunks = 0
 **/